import { SUMMARY_PROGRESS_DATA_SURVEY_VIEW, SUMMARY_PROGRESS_DATA_SURVEY_EDIT } from '@/fixtures'

export default {
  path: 'summary-progress-data-survey',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Upload Survey Data',
      component: () => import('@/views/menus/SummaryProgressDataSurvey/Index'),
      meta: {
        permission: SUMMARY_PROGRESS_DATA_SURVEY_VIEW
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Survey Data',
      component: () => import('@/views/menus/SummaryProgressDataSurvey/Edit'),
      meta: {
        permission: SUMMARY_PROGRESS_DATA_SURVEY_EDIT
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Survey Data',
      component: () => import('@/views/menus/SummaryProgressDataSurvey/View'),
      meta: {
        permission: SUMMARY_PROGRESS_DATA_SURVEY_VIEW
      }
    }
  ]
}
